import React from "react";
import Navigation from "./Navigation";
import Socials from "./Socials";

const Header = () => {
  return (
    <header>
      <Navigation />
    </header>
  );
};

export default Header;
